import { render, staticRenderFns } from "./PracticeForm.vue?vue&type=template&id=13c0f755&"
import script from "./PracticeForm.vue?vue&type=script&lang=js&"
export * from "./PracticeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports